import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '../../public/assets/images/GERENCIAMEI_ICON.svg'


const _hoisted_1 = { class: "flex flex-col w-full h-full" }
const _hoisted_2 = { class: "flex justify-between items-center py-3 px-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-14",
  src: _imports_0
}, null, -1)
const _hoisted_4 = { class: "text-sm font-bold" }
const _hoisted_5 = {
  key: 0,
  class: "text-xs text-gray-100"
}
const _hoisted_6 = {
  key: 1,
  class: "text-xs text-gray-100"
}
const _hoisted_7 = {
  key: 0,
  class: "bg-red-500 rounded-md w-3 h-3 absolute right-0.5 top-0.5 z-50"
}


import {
	IonHeader,
	IonToolbar,
	IonButtons,
	IonMenuButton,
	useIonRouter,
} from "@ionic/vue";
import { useUser } from "@/composables/user";
import { filterCnpj } from "@/helpers/filters";
import { useNotifications } from "@/composables/notifications";

export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
    title: null
  },
  setup(__props: any) {

const ionRouter = useIonRouter();
const { user } = useUser();

const { unread } = useNotifications();

const handleUserCnpj = () => {
	if (user.value && user.value.cnpj) ionRouter.push("/cnpj-card/");
	else ionRouter.push("/load-cnpj/");
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonHeader), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonToolbar), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", {
                class: "flex flex-col items-center text-gray-50",
                onClick: handleUserCnpj
              }, [
                _createElementVNode("h1", _hoisted_4, "Olá, " + _toDisplayString(_unref(user)?.name), 1),
                (_unref(user) && _unref(user).cnpj)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, " CNPJ: " + _toDisplayString(_unref(filterCnpj)(_unref(user).cnpj)), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, " Abra ou cadastre seu CNPJ "))
              ]),
              _createVNode(_unref(IonButtons), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonMenuButton), {
                    "auto-hide": false,
                    color: "light"
                  }),
                  (_unref(unread) > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})